<template>
  <div class="d-flex justify-center align-top my-7" style="width: 100%; height: 100%">
    <div style="width: 100%; max-width: 1000px;" class="align-top" v-if="isAdmin">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h3>Rss Sources</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-3">
            <RssSource class="pb-6" />
            <RssSourceList />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h3>Organization Management</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-3">
            <OrganizationManagement />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { types } from '@/store/rootTypes';
import RssSource from './RssSource';
import RssSourceList from './RssSourceList';
import OrganizationManagement from './OrganizationManagement';

export default {
  name: 'Admin',
  components: { RssSource, OrganizationManagement, RssSourceList },
  computed: {
    ...mapGetters({
      isAdmin: types.authentication.getters.isAdmin,
    }),
  },
  methods: {
    ...mapActions({
      fetchOrganizations: types.authentication.actions.fetchOrganizations,
      unsubscribeOrganizations: types.authentication.actions.unsubscribeOrganizations,
    }),
  },
  created() {
    this.fetchOrganizations();
  },
  detroyed() {
    this.unsubscribeOrganizations();
  },
};
</script>
